import {
  CheckboxCardInputType,
  InputSize,
  Layout,
  RedoCheckboxCard,
} from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox-card";
import { memo, ReactNode } from "react";

export interface PortalSelectionCardProps {
  title: ReactNode;
  children?: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  inputType?: CheckboxCardInputType;
  inputSize?: InputSize;
  layout?: Layout;
  icon?: ReactNode;
  dataTestId?: string;
  uiSelector?: string;
}

export const PortalSelectionCard = memo(function PortalSelectionCard({
  title,
  children,
  selected = false,
  disabled,
  onClick,
  inputType,
  inputSize = "sm",
  layout = Layout.SHORT,
  icon,
  dataTestId,
  uiSelector,
}: PortalSelectionCardProps) {
  return (
    <RedoCheckboxCard
      bgColor="primary"
      checked={selected}
      dataTestId={dataTestId}
      disabled={disabled}
      icon={icon}
      inputSize={inputSize}
      inputType={inputType}
      layout={layout}
      onClick={disabled ? undefined : onClick}
      title={title}
      uiSelector={uiSelector}
    >
      {children}
    </RedoCheckboxCard>
  );
});
